import { useRoutes } from 'react-router-dom';
import MainRoutes from './MainRoutes';
import AdminRoutes from './AdminRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import { getRoleFromToken } from 'core/apis/common';
import { role } from 'core/constant/constants';
import PaymentRoutes from './PaymentRoutes';

const checkToken = () => {
  const token = localStorage.getItem("token");
  return !token;
};
const checkRole = getRoleFromToken()

export default function ThemeRoutes() {

  const routes = checkToken() ? AuthenticationRoutes : (checkRole == role?.superAdmin) ? AdminRoutes : MainRoutes;

  return useRoutes([routes, PaymentRoutes]);
}
